import React, {useState, useEffect, useRef} from 'react'
import {withRouter} from 'react-router-dom'
import MuiButton from '@material-ui/core/Button'
import {useDispatch, useSelector} from 'react-redux'
import {saveApplication} from 'lms/store/actions'
import {useEditApplication} from 'lms/hooks'
import {getMode} from 'app/store/selectors'
import CircularProgress from '@material-ui/core/CircularProgress'

const SaveButton = ({history, ...props}) => {
  const [application] = useEditApplication()
  const dispatchRedux = useDispatch()
  const mode = useSelector(getMode)
  const [saving, setSaving] = useState(false)
  // Use a ref to track if component is mounted
  const isMounted = useRef(true)
  // Store the timeout ID
  const timeoutRef = useRef(null)
  
  // Set up the cleanup function to handle unmounting
  useEffect(() => {
    // Set mounted flag to true on mount
    isMounted.current = true
    
    // Clean up on unmount
    return () => {
      isMounted.current = false
      // Clear any pending timeouts when unmounting
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])
  
  const handleUpdate = () => {
    setSaving(true)
    dispatchRedux(saveApplication())
    
    // Store the timeout ID so we can clear it if needed
    timeoutRef.current = setTimeout(() => {
      if (!isMounted.current) return
      
      // Redirect based on user role
      const modeValue = mode && typeof mode === 'string' ? mode.toLowerCase() : ''
      
      // Admin goes to catalog, all others (vendor, user) go to systems
      if (modeValue === 'admin') {
        history.push('/catalog')
      } else {
        history.push('/systems')
      }
      
      // Only update state if component is still mounted
      if (isMounted.current) {
        setSaving(false)
      }
    }, 1000)
  }

  const title = application.id === 'new' ? "Create" : "Update"

  const descriptionTooLong = (application.description?.length || 0) > 300

  return (
    <MuiButton
      color="primary"
      variant="contained"
      onClick={handleUpdate}
      disabled={props.disabled || saving || descriptionTooLong}
    >
      {saving ? (
        <>
          <CircularProgress size={16} color="inherit" style={{marginRight: 8}} />
          Saving...
        </>
      ) : (
        title
      )}
    </MuiButton>
  )
}

export default withRouter(SaveButton)
